<template lang="pug">      
  nt-dialog(
    v-model='dialog'
    :title="$t('promotion-lock')"
    :subtitle="$t('promotion-lock-subtitle')"
    align="center"
    max-width="700"
    scrollable
    title-center
  )
    div.promotion-container
      div(
        v-for='(item, i) in promotions'
        :key='i'
      ) 
        card-promotion(:item="item", :prePromotion="true", big-sub-desc).card-promotion
</template>
<script>
import CardPromotion from '@/components/Promotion/CardPromotion'
import { vouchers as apiVouchers  } from '@/apis'  

export default {
  components : {
    CardPromotion,
  },

  data: () => ({ 
    showRaw: false,
    dialog: false, 
    promotions: [], 
  }),

  methods : {
    async getVouchers () {  
      const [,data,,] = await apiVouchers.list({'type': 'turnover'})

      this.promotions = data
    },
    
    async open () {
      await this.getVouchers();

      this.dialog = true
    },
    close () {
      this.dialog = false
    }
  }
}
</script>
<style scoped>
.promotion-container {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: 1fr;
  padding-left: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  overflow-x: hidden;
}

@media only screen and (max-width: 799px) {
  .promotion-container {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media only screen and (max-width: 450px) {
  .card-promotion {
    width: calc(92vw - 25px)
  }
}

</style>